$(function() {
	const $phone = $('input[type="tel"]');
	const regex = '\\+7 \\([0-6,9]{1}[0-9]{2}\\) [0-9]{3}–[0-9]{2}–[0-9]{2}';
	$phone.inputmask({ regex })
})